import "./App.css";
import AppRouter from "./components/Router";
import BasicPageTem from "./templates/BasicPageTem";
import './i18n'; 

function App() {
  return <BasicPageTem />;
}

export default App;
